import React from 'react'
import { PopupWidget } from "react-calendly";
import Form from '../components/Form'
import { Helmet } from 'react-helmet-async'

function Project_management() {
  return (
    <>
       <Helmet>
                    <title>Project Management</title>
                     <meta name="description" content="Our Project Management Services are designed to ensure the seamless execution of your projects 
                      from initiation to completion"/>
                      <link rel="canonical" href="/project_management"/>
                       </Helmet>
 
    <div>
          <div className="container-fluid bg-primary py-5 mb-5 hero-header">
    <div className="container py-5">
      <div className="row justify-content-center py-5">
        <div className="col-lg-10 pt-lg-5 mt-lg-5 text-center">
          <h1 className="display-3 text-white animated slideInDown">
          Project Management
          </h1>
        </div>
      </div>
    </div>
  </div>
  <div className="container-xxl py-5">
      <div className="container">
        <div className="row g-5">
        <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.3s">
        <h1 className="mb-4">
             <span className="text-primary"> Project Management</span>
            </h1>
        <p className="mb-4">
        Our Project Management Services are designed to ensure the seamless execution of your projects 
        from initiation to completion. We utilize industry-proven methodologies and cutting-edge tools 
        like <b>Jira</b> and <b>Asana</b> to plan, track, and manage every aspect of your projects. With a focus on efficiency, 
        collaboration, and delivering results on time, within scope, and on budget, we provide the expertise needed 
        to turn your ideas into successful outcomes.
            </p>
            <h4 className="mb-4">
            Key Benefits of Our Project Management Services
            </h4>
            <ul>
                <li>Improved Efficiency: Streamlined processes boost productivity.</li>
                <li>Reduced Risks: Minimize disruptions with proactive planning.</li>
                <li>Enhanced ROI: Effective resource allocation for better returns.</li>
                <li>Goal Alignment: Projects align with your business objectives.</li>
            </ul>
            <section class="process">
            <h2>Our Process</h2>
            <ol>
                <li><strong>Discovery:</strong> Understand your project vision, challenges, and goals.</li>
                <li><strong>Planning:</strong> Create a roadmap with timelines and resources.</li>
                <li><strong>Execution:</strong> Implement the project plan while staying flexible.</li>
                <li><strong>Monitoring:</strong> Track progress and address issues proactively.</li>
                <li><strong>Closure:</strong> Deliver the final output and ensure smooth handover.</li>
            </ol>
        </section>
          </div>
          <div
            className="col-lg-6 wow fadeInUp"
            data-wow-delay="0.1s"
            style={{ minHeight: 400 }}
          >
            <div className="position-relative h-100">
              <img
                className="img-fluid position-absolute w-100 h-100"
                src="https://view.subpage.app/app/company/C532b8873cc5442e2b1f2265b77a7d7dc/domain/MTiT0jFlGh/page/Ma9aQb2DGh/article/M52e59e269bfbc6d871027a280eb17cb21721814253357/hero/M4cd31c583ffb66e17295695c64b440bd1722590762244.webp"
                alt=""
                style={{ objectFit: "cover" }}
              />
            </div>
          </div>
       
        </div>
      </div>
    </div>
      {/* card Start */}
      <div className="container-xxl py-5 wow fadeInUp" data-wow-delay="0.1s">
   
      <section id="services" class="services">
        <div class="container">
            <h2>Our Project Management Services</h2>
            <div class="services-grid">
                <div class="service-card">
                    {/* <i class="fa fa-3x fa-tools service-icon text-primary mb-1"></i> */}
                
                    <h3>Strategic Planning and Execution</h3>
                    <p>Define your project scope, objectives, and success criteria with clear milestones.</p>
                </div>
                <div class="service-card">
                    {/* <i class="fa fa-3x fa-cogs service-icon text-primary mb-1"></i> */}
                    <h3>Agile Project Management</h3>
                    <p>Leverage Agile methodologies for fast, flexible, and high-quality results.</p>
                </div>
                <div class="service-card">
                    {/* <i class="fa fa-3x fa-warehouse service-icon text-primary mb-1"></i> */}
                    <h3>Risk Management and Mitigation</h3>
                    <p>Anticipate challenges and minimize disruptions with proactive risk management.</p>
                </div>
                <div class="service-card">
                    {/* <i class="fa fa-3x fa-shield-alt service-icon text-primary mb-1"></i> */}
                    <h3>Tools and Technology Integration</h3>
                    <p>Enhance efficiency with cutting-edge tools and automated workflows.</p>
                </div>
                <div class="service-card">
                    <h3>Stakeholder Communication</h3>
                    <p>Keep all stakeholders aligned with clear and transparent updates.</p>
                </div>

            </div>
        </div>
    </section>
    <header className="hero">
                                <div className="hero-content">
                                    <h2>Let’s Build Your Digital Future</h2>
                                    <p>Partner with us to create innovative websites and seamless eCommerce solutions that drive results.</p>
                                    <a href='/Contact'><button className="contact-button">Contact Us</button></a>
                                </div>
                            </header>

<PopupWidget
                    url="https://calendly.com/nagspros"
                    rootElement={document.getElementById('root')}
                    text="Schedule a Consultation!"
                    textColor="#ffffff"
                    color="#346815FF"
                />
    </div>
    </div>
    </>
  )
}

export default Project_management
